import KanbanBoard from './components/KanbanBoard';

export default function ProductionPage() {
  return (
    <div>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-stone-900">Üretim Takibi</h2>
          <p className="text-sm text-stone-500 mt-0.5">Sürükle-bırak ile üretim aşamalarını yönetin</p>
        </div>
        <div className="flex items-center gap-2">
          <button className="px-4 py-2 bg-white border border-stone-200 text-stone-600 text-sm font-medium rounded-lg hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-refresh-line mr-1" />Yenile
          </button>
          <button className="px-4 py-2 bg-gold-500 text-white text-sm font-medium rounded-lg hover:bg-gold-600 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-filter-3-line mr-1" />Filtrele
          </button>
        </div>
      </div>

      {/* Kanban */}
      <KanbanBoard />
    </div>
  );
}